import { type DatabaseStreamHookState } from '@databases/database-ai-first-creation-ui';

import { useIsAiSummaryFieldEnabled } from './summary/use-is-ai-summary-field-enabled.ts';

/**
 * Whether AI Summary generation is active for either a single cell or an entire field.
 *
 * Use this to suppress AIFC streaming visuals while the cell shows its AI Summary
 * loading placeholder.
 */
export const useIsAiFieldStreaming = (
  activeStream: DatabaseStreamHookState['activeStream']
): boolean => {
  const isAiSummaryFieldEnabled = useIsAiSummaryFieldEnabled();

  return isAiSummaryFieldEnabled && activeStream?.kind === 'ai-field';
};

/**
 * Whether AI Summary generation is active for an entire field, rather than one cell.
 *
 * Use this for field-level feedback, such as the column header streaming gradient.
 */
export const useIsFieldScopedAiStreaming = (
  activeStream: DatabaseStreamHookState['activeStream']
): boolean => {
  return (
    useIsAiFieldStreaming(activeStream) &&
    activeStream?.kind === 'ai-field' &&
    activeStream.target.scope === 'field'
  );
};
